<style lang="less" scoped>
.pagebottom {
  background: #2c354e;
  color: #e2e2e2;
  // position: fixed;
  width: 100%;
  bottom: 0;
  padding: 8px 10px;
  font-family: "Microsoft YaHei";
  font-size: 10px;
  p {
    text-align: center;
    img {
      vertical-align: middle;
      width: 15px;
      margin-right: 5px;
    }
    a {
      color: #e2e2e2;
    }
  }
}
</style>
<template>
  <section>
    <div class="pagebottom">
      <p>
        <img src="../assets/images/shiye.png" /><a
          href="https://www.beian.gov.cn/portal/recordQuery"
          target="_blank"
          >{{ $t("footer.footer1") }}</a
        >
      </p>
      <p>
        <a href="https://www.beian.gov.cn/portal/recordQuery" target="_blank">{{
          $t("footer.footer5")
        }}</a>
      </p>
      <p>{{ $t("footer.footer6") }}{{ $t("footer.footer7") }}</p>
      <p v-if="lang != 'en'">
        <a
          style="display: inline-block"
          href="https://beian.miit.gov.cn/"
          target="_blank"
        >
          {{ $t("footer.footer2") }}</a
        >
      </p>
    </div>
  </section>
</template>
<script>
export default {
  data() {
    return {
      lang: "",
    };
  },
  mounted() {
    this.lang = this.$cookie.get("lang");
  },
};
</script>